import CommonCityMappingRoute from './CommonCityMappingRoute'
import ConnectorAppConfigRoute from './ConnectorAppConfigRoute'
import CecUomConversionRoute from './CecUomConversionRoute'
import CecDoUomMappingRoute from './CecDoUomMappingRoute'
import CecPostcodeConfigRoute from './CecPostcodeConfigRoute'
import ConnectorMappingRoute from './ConnectorMappingRoute'
import ShipmentProviderRoute from './ShipmentProviderRoute'
import ShipmentProviderConnectorMappingRoute from './ShipmentProviderConnectorMappingRouter'
import PartyConfigRoute from './PartyConfigRoute'
import QuotationRoute from "./QuotationRoute"
import ReportRoute from "./ReportRoute";

const routes = [
    new CommonCityMappingRoute(),
    new CecUomConversionRoute(),
    new CecDoUomMappingRoute(),
    new CecPostcodeConfigRoute(),
    new ConnectorAppConfigRoute(),
    new ConnectorMappingRoute(),
    new ShipmentProviderRoute(),
    new ShipmentProviderConnectorMappingRoute(),
    new PartyConfigRoute(),
    new QuotationRoute(),
    new ReportRoute()
]

export default routes
